<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>版本管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <Button type="primary" icon="ios-paperplane-outline" @click="showDialog" v-if="authList.indexOf('002002') !== -1">添加版本</Button>
        </div>

        <Table border height="520" ref="version_table" :columns="columns" :data="tableData"></Table>
        <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除设备？</p>
    </Modal>
    <modal
      v-model="dialog"
      title="请选择需要上传的升级包"
      @on-ok="confirm"
      @on-cancel="cancel">
      <Upload :before-upload="beforeUpload" ref="upload" :action="action" @on-success="uploadSuccess">
        <Button type="ghost" icon="ios-cloud-upload-outline">选择文件</Button>
      </Upload>
      <div v-if="versionFile !== null">本次上传的文件: {{ versionFile.name }}</div>
    </modal>
    <modal
      v-model="memoDialog"
      title="修改版本备注"
      @on-ok="confirmModifyMemo"
      @on-cancel="cancel">
      <Input v-model="memo" type="textarea" :rows="4" placeholder="Enter something..." />
    </modal>
  </div>
</template>

<script>
import NavList from '../nav-list/nav-list'
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {nSuccess} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'
import {getAuthStr} from '../../util/bus'

export default {
  components: {
    TopOpe,
    NavList},
  name: 'version-management',
  data () {
    return {
      authList: '',
      openSimple: false,
      dialog: false,
      memoDialog: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '版本号',
          key: 'versionNo',
          align: 'center'
        }, {
          title: '备注',
          key: 'memo',
          align: 'center'
        }, {
          title: '上传时间',
          key: 'createTime',
          align: 'center'
        }, {
          title: '操作',
          key: 'operation',
          align: 'center',
          render: (h, params) => {
            if (params.row.authStatus) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.modifyMemo(params.row)
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.deleteDev(params.row.id)
                    }
                  }
                }, '删除')
              ])
            }
          }
        }
      ],
      reqbody: {
        pageSize: 10,
        pageNo: 1
      },
      tableData: [],
      total: 0,
      deleteDevId: {},
      memo: '',
      memoModifyId: '',
      versionFile: null,
      action: ''
    }
  },
  created () {
    this.authList = getAuthStr()
    this.action = `${httpUrl.url}/manage/version/add`
    this.getVersionInfo()
  },
  methods: {
    getVersionInfo () {
      this.$axios.post(`${httpUrl.url}/manage/version/getPage`, this.reqbody)
        .then(res => {
          let data = res.data.data
          data.list.map(v => {
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            } else {
              v.createTime = '--'
            }
          })
          if (this.authList.indexOf('002001') !== -1) {
            data.list.map(v => {
              v.authStatus = true
            })
          } else {
            data.list.map(v => {
              v.authStatus = false
            })
          }
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    modifyMemo (data) {
      this.memo = data.memo
      this.memoModifyId = data.id
      this.memoDialog = true
    },
    confirmModifyMemo () {
      this.$axios.post(`${httpUrl.url}/manage/version/update`, {
        id: this.memoModifyId,
        memo: this.memo
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.memoDialog = false
            this.memo = ''
            this.getVersionInfo()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    deleteDev (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/version/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.getVersionInfo()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    showDialog () {
      this.dialog = true
      this.versionFile = null
      this.$refs.upload.clearFiles()
    },
    uploadSuccess () {
      this.$refs.upload.clearFiles()
    },
    cancel () {
      this.dialog = false
      this.memoDialog = false
    },
    confirm () {
      this.dialog = false
      this.getVersionInfo()
    },
    beforeUpload (file) {
      this.versionFile = file
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getVersionInfo()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getVersionInfo()
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/version-management/version-management.vue